import MuiBox from '@new-components/atoms/MuiBox';
import MuiButton from '@new-components/atoms/MuiButton';
import MuiTypography from '@new-components/atoms/MuiTypography';
import {PRIMARY_MESSAGE, SECONDARY_MESSAGE} from './constants';
import {SuccessLogo} from './icon';
import {ImageObj} from '@custom-types/ImageObj.types';
import styles from './styles';
import Image from 'next/image';
import ReactHtmlParser from '@libs/reactHtmlParser';

type Props = {
  /**
   * function to be called when the Finish button is clicked.
   */
  handleOnClick: () => void;
  /**
   * Custom message to be displayed as the primary message.
   */
  primaryMessage?: string;
  /**
   * Custom message to be displayed as the secondary message.
   */
  secondaryMessage?: string;
  /**
   * QR image data
   */
  image?: ImageObj;
};

const RegisterInterestSuccess = (props: Props) => {
  return (
    <MuiBox sx={styles.container}>
      <MuiBox sx={styles.box}>
        <SuccessLogo />
        <MuiTypography component='div' sx={styles.primary}>
          {props.primaryMessage
            ? ReactHtmlParser(props.primaryMessage)
            : PRIMARY_MESSAGE}
        </MuiTypography>
        <MuiTypography component='div' sx={styles.secondary}>
          {props.secondaryMessage
            ? ReactHtmlParser(props.secondaryMessage)
            : SECONDARY_MESSAGE}
        </MuiTypography>
        {props.image && (
          <MuiBox sx={{marginTop: '20px'}}>
            <Image
              src={props.image?.url}
              alt={props.image?.alt}
              height={150}
              width={150}
            />
          </MuiBox>
        )}
      </MuiBox>
      <MuiButton fullWidth sx={styles.btn} onClick={props.handleOnClick}>
        Finish
      </MuiButton>
    </MuiBox>
  );
};

export default RegisterInterestSuccess;
